<div
  #containerRef
  class="hx-splitter"
  [class.hx-splitter--horizontal]="orientation() === 'horizontal'"
  [class.hx-splitter--vertical]="orientation() === 'vertical'"
  [class.hx-splitter--dragging]="isDragging()"
  [class.hx-splitter--disabled]="disabled()"
  [style.flex-direction]="flexDirection()">
  <!-- Panel 1 -->
  <div
    class="hx-splitter__panel hx-splitter__panel--first"
    [style.flex-basis]="panel1Style()['flex-basis']"
    [style.flex-grow]="0"
    [style.flex-shrink]="0"
    [style.overflow]="'auto'">
    <ng-container *ngTemplateOutlet="templates()[0]"></ng-container>
  </div>

  <!-- Splitter Handle -->
  <hx-splitter-handle
    [orientation]="orientation()"
    [disabled]="disabled()"
    [ariaLabel]="ariaLabel()"
    [ariaValueNow]="panel1PercentageSignal()"
    [ariaValueMin]="minPercentage()"
    [ariaValueMax]="maxPercentage()"
    (handleMouseDown)="onHandleMouseDown($event)"
    (handleTouchStart)="onHandleTouchStart($event)"
    (handleKeyDown)="onHandleKeyDown($event)"></hx-splitter-handle>

  <!-- Panel 2 -->
  <div
    class="hx-splitter__panel hx-splitter__panel--second"
    [style.flex-basis]="panel2Style()['flex-basis']"
    [style.flex-grow]="0"
    [style.flex-shrink]="0"
    [style.overflow]="'auto'">
    <ng-container *ngTemplateOutlet="templates()[1]"></ng-container>
  </div>

  <!-- Screen reader announcements -->
  <div class="hx-splitter__sr-only" aria-live="polite" aria-atomic="true">
    {{ screenReaderMessage() }}
  </div>
</div>
